import {Component, DoCheck, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TwoFAService} from '../../_services';
import {SharedService} from '../../shared/shared.service';
import {Constants} from '../../shared/Helpers/constants';
import { Alert, AlertTypeEnum } from 'src/app/shared/Helpers/Alert';

@Component({
  selector: 'app-two-fa-confirmation',
  templateUrl: './two-fa-confirmation.component.html'
})
export class TwoFaConfirmationComponent implements OnInit, DoCheck {
  public showLoading: boolean = true;
  public changeConfirmed: boolean = false;
  public logoPath: any;
  public returnUrl: string;
  public answer: boolean;
  private tenant: string | any;
  private secret: any;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _twoFAService: TwoFAService,
    private sharedService: SharedService
  ) {
    this.tenant = this._activatedRoute.snapshot.paramMap.get('tenant');
    this.answer = this._activatedRoute.snapshot.paramMap.get('answer')?.toLowerCase() == 'true';
    this.secret = this._activatedRoute.snapshot.paramMap.get('secret');
  }

  ngOnInit(): void {
    this._twoFAService.confirmDeviceChange(this.secret, Boolean(this.answer), this.tenant).subscribe({
      next: () => {
        this.showLoading = false;
        this.changeConfirmed = true;
      },
      error: () => {
        this.showLoading = false;
        this.changeConfirmed = false;
        const errorMessage: string = `Sorry, this link has expired.`;
        Alert.basicNotification(AlertTypeEnum.Error, "", errorMessage);
      }
    })
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        } else {
          this.logoPath = Constants.logoPath;
        }
      } else {
        this.logoPath = Constants.logoPath;
      }
    } else {
      this.logoPath = Constants.logoPath;
    }
  }

}
